<template>
  <div class="icon-badge" :class="classes">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    type?: "success";
  }>(),
  { type: "success" }
);

const classes = {
  success: "icon-badge--success text-success",
}[props.type];
</script>

<style>
.icon-badge {
  width: 64px;
  height: 64px;
  border-radius: 100px;
  padding: 10px;
  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-badge--success {
  background-color: #e4f4eb;
}
</style>
